import React from 'react';
import './ErrorBox.css';
const ErrorBox = (props) => {
    return <div className="error-box">
        {props.icon !=="false" ? <span className="error-icon"></span> :""}
        <span className="error-text"> {props.children}</span>
    </div>
}

export default ErrorBox;